module.exports = __webpack_public_path__ + "img/3.9a2a4b5a.jpg";